<template>
  <div class="ledger">
    <h1 style="margin-bottom: 12px">🤝 已互关 / 建联记录</h1>
    <!-- 筛选栏 -->
    <el-card shadow="never" class="filter-card">
      <div class="filter-row">
        <el-select v-model="query.account_id" placeholder="全部账号" clearable style="width: 180px" @change="load">
          <el-option v-for="a in accounts" :key="a.id" :label="`${a.username || ('账号' + a.id)}`" :value="a.id" />
        </el-select>
        <el-select v-model="query.action" placeholder="全部动作" clearable style="width: 140px" @change="load">
          <el-option label="私信" value="dm" />
          <el-option label="评论" value="comment" />
          <el-option label="关注" value="follow" />
          <el-option label="留痕" value="trace" />
        </el-select>
        <el-select v-model="query.platform" placeholder="全部平台" clearable style="width: 130px" @change="load">
          <el-option label="抖音" value="douyin" />
          <el-option label="快手" value="kuaishou" />
        </el-select>
        <el-select v-model="query.days" style="width: 140px" @change="load">
          <el-option label="最近1天" :value="1" />
          <el-option label="最近3天" :value="3" />
          <el-option label="最近7天" :value="7" />
          <el-option label="最近30天" :value="30" />
        </el-select>
        <el-button type="primary" @click="load">查询</el-button>
        <el-button @click="refresh">刷新</el-button>
      </div>

      <!-- 汇总统计 -->
      <div v-if="summaryKeys.length" class="summary">
        <el-tag v-for="k in summaryKeys" :key="k" class="summary-tag" effect="plain">
          {{ k }}：{{ summary[k] }} 条
        </el-tag>
        <el-tag type="success" class="summary-tag">共 {{ total }} 条</el-tag>
      </div>
    </el-card>

    <!-- 明细表 -->
    <el-card shadow="never">
      <el-table :data="items" v-loading="loading" stripe empty-text="暂无建联记录（生产任务会自动记账：互关/私信/评论/关注）">
        <el-table-column prop="created_at" label="时间（北京时间）" width="170" />
        <el-table-column label="平台" width="90">
          <template #default="{ row }">
            <el-tag :type="row.platform === 'kuaishou' ? 'warning' : ''" size="small">
              {{ platformText(row.platform) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="account" label="账号" width="130" />
        <el-table-column label="动作" width="90">
          <template #default="{ row }">
            <el-tag :type="actionType(row.action)" size="small">{{ row.action_label }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="target_username" label="目标用户" width="140" show-overflow-tooltip />
        <el-table-column label="内容" min-width="280" show-overflow-tooltip>
          <template #default="{ row }">
            <span v-if="row.action === 'dm'">{{ row.content }}</span>
            <span v-else>{{ row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template #default="{ row }">
            <el-tag :type="row.status === 'sent' ? 'success' : 'danger'" size="small">
              {{ row.status === 'sent' ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="detail" label="详情" min-width="200" show-overflow-tooltip />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Ledger',
  data() {
    return {
      query: { account_id: 0, action: '', days: 7, platform: 'douyin' },
      accounts: [],
      items: [],
      summary: {},
      total: 0,
      loading: false,
      _timer: null,
    }
  },
  computed: {
    summaryKeys() {
      return Object.keys(this.summary || {})
    },
  },
  async mounted() {
    await this.loadAccounts()
    await this.load()
    // 每 30 秒自动刷新，保证"已互关/建联"数据及时同步
    this._timer = setInterval(() => {
      if (!this.loading) this.load()
    }, 30000)
  },
  beforeUnmount() {
    if (this._timer) clearInterval(this._timer)
  },
  methods: {
    platformText(p) {
      const map = { douyin: '抖音', kuaishou: '快手', xhs: '小红书' }
      return map[p] || p || '抖音'
    },
    async loadAccounts() {
      try {
        const r = await api.get('/accounts/')
        this.accounts = r || []
      } catch (e) {
        console.error('加载账号失败', e)
      }
    },
    async load() {
      this.loading = true
      try {
        const params = {
          days: this.query.days || 7,
          limit: 300,
        }
        if (this.query.account_id) params.account_id = this.query.account_id
        if (this.query.action) params.action = this.query.action
        if (this.query.platform) params.platform = this.query.platform
        const r = await api.get('/leads/ledger', { params })
        this.items = r.items || []
        this.summary = r.summary || {}
        this.total = r.total || 0
      } catch (e) {
        console.error('加载账本失败', e)
        this.$message.error('加载账本失败：' + (e.response?.data?.detail || e.message))
      } finally {
        this.loading = false
      }
    },
    refresh() {
      this.load()
    },
    actionType(a) {
      return { dm: 'warning', comment: 'success', follow: 'primary', trace: 'info' }[a] || 'info'
    },
  },
}
</script>

<style scoped>
.ledger {
  padding: 4px;
}
.filter-card {
  margin-bottom: 12px;
}
.filter-row {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.summary {
  margin-top: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.summary-tag {
  font-size: 13px;
}
</style>
